import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import RoutesComponent from './routes';
import logo from './static/img/logo.png';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  if (loading) {
    return (
      <div className="loading-screen">
        <img src={logo} alt="logo" className="loading-logo" />
      </div>
    );
  }

  return (
    <Router>
      <RoutesComponent />
    </Router>
  );
}

export default App;
